import { useMutation, useQuery } from "react-query";
import { createLetter, fetchLetterDetail, updateLetter } from "@/services/letter";
/** Mutation hook that creates a letter from raw HTML. */
export function useCreateLetter(patientUid) {
  return useMutation(function (payload) {
    return createLetter(patientUid, payload);
  });
}

/** Mutation hook that saves edits to an existing letter. */
export function useUpdateLetter(patientUid) {
  return useMutation(function (_ref) {
    var letterId = _ref.letterId,
      letter = _ref.letter;
    return updateLetter(patientUid, letterId, letter);
  });
}

/** Query hook for a single letter's detail. */
export function useLetterDetail(patientUid, letterId) {
  return useQuery(["letter-detail", patientUid, letterId], function () {
    return fetchLetterDetail(patientUid, letterId);
  }, {
    enabled: Boolean(patientUid) && Boolean(letterId)
  });
}